module.exports = __webpack_public_path__ + "static/img/lunbo1.631a1ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/lunbo/lunbo1.png
// module id = UdJe
// module chunks = 6